/** RFC 9457 problem document as produced by the backend (ARCHITECTURE §8). */
export interface ProblemDetail {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  /** Stable domain error code, e.g. INVENTORY_INSUFFICIENT_STOCK. */
  code?: string;
  timestamp?: string;
  errors?: { field: string; message: string }[];
  /**
   * Extra members a refusal adds to explain itself — `suspensionReason` on a 423, for instance
   * (US-14.7). RFC 9457 allows them, and a message can then say *why* rather than only *that*.
   */
  [extra: string]: unknown;
}

export function isProblemDetail(value: unknown): value is ProblemDetail {
  return typeof value === "object" && value !== null && "status" in value && "code" in value;
}

/** Best-effort human readable message for an unknown API error. */
export function problemMessage(error: unknown, fallback: string): string {
  if (isProblemDetail(error)) {
    return error.detail ?? error.title ?? fallback;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return fallback;
}
